import { GzToastNotificationWebComponent } from '../../..';
import { GzToast, ToastPositionX, ToastPositionY, ToastSeverity } from '../../../ui/gzToastNotification/type';

interface CreateToastNotificationParams {
  message: string;
  severity?: ToastSeverity;
}

export class PackagesToastNotification {
  static createToastNotification({ message, severity = ToastSeverity.SUCCESS }: CreateToastNotificationParams) {
    const toastNotificationConfigs: GzToast = {
      message,
      severity,
      x: ToastPositionX.RIGHT,
      y: ToastPositionY.BOTTOM,
      autoCloseDelayMs: 10000,
      showInlineButton: true,
    };

    GzToastNotificationWebComponent.buildToastWrapperElement(toastNotificationConfigs);
  }
}
